import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBook = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "book_2_2",
		d: "M4.99935 15.1667C4.3549 15.1667 3.8049 14.9389 3.34935 14.4834C2.89379 14.0278 2.66602 13.4778 2.66602 12.8334V4.16671C2.66602 3.52226 2.89379 2.97226 3.34935 2.51671C3.8049 2.06115 4.3549 1.83337 4.99935 1.83337H13.3327V11.8334C13.0549 11.8334 12.8188 11.9306 12.6243 12.125C12.4299 12.3195 12.3327 12.5556 12.3327 12.8334C12.3327 13.1112 12.4299 13.3473 12.6243 13.5417C12.8188 13.7362 13.0549 13.8334 13.3327 13.8334V15.1667H4.99935ZM5.33268 10.5H6.66602V3.16671H5.33268V10.5ZM4.99935 13.8334H11.216C11.1493 13.6778 11.0966 13.5195 11.0577 13.3584C11.0188 13.1973 10.9993 13.0223 10.9993 12.8334C10.9993 12.6556 11.016 12.4834 11.0493 12.3167C11.0827 12.15 11.1382 11.9889 11.216 11.8334H4.99935C4.71046 11.8334 4.47157 11.9306 4.28268 12.125C4.09379 12.3195 3.99935 12.5556 3.99935 12.8334C3.99935 13.1223 4.09379 13.3612 4.28268 13.55C4.47157 13.7389 4.71046 13.8334 4.99935 13.8334Z",
		fill: "currentColor"
	})
});
export default SvgBook;
